
    import Multiselect from '@vueform/multiselect'
    import BotaoSalvar from '@/components/aplicacao/BotaoSalvar.vue';
    import { Options, Vue } from "vue-class-component";
    import { PerfilConfig } from "@/core/config/PerfisConfig";
    import SiteUtils from '@/assets/ts/aplicacao/site';
    import $ from "jquery"
    import { Prop } from 'vue-property-decorator';
    import EspacoService from "@/service/v1/sigap/EspacoService"

    @Options({
        name: "EspacoCadastro",
        components: { Multiselect, BotaoSalvar },
        emits: ['espaco-cadastrado'],
    })
    export default class EspacoCadastro extends Vue {
        @Prop() readonly modal!: any
        @Prop() readonly perfis!: any

        public service = new EspacoService();
        public processando = false;
        public titulo = 'Cadastrar Espaco';

        public nome: any = null;
        public descricao: any = null;
        public observacao: any = null;
        public statusId: any = null;
        public status: any = null;

        created() {
            this.getStatus();
        }

        get hasPermissao(): boolean {
            return SiteUtils.hasPermissao([PerfilConfig.Admin, PerfilConfig.ChefeSTE], this.perfis);
        }

        get statusSelect() {
            if (this.status) {
                return this.status.map((item) => { return { value: item.id, label: item.nome } });
            }
            return null;
        }

        public getStatus() {
            this.processando = true;
            this.service.getStatus()
                .then(response => {
                    this.status = JSON.parse(JSON.stringify(response));
                    this.processando = false;
                })
                .catch(error => {
                    this.processando = false;
                });
        }

        public getdados() {
            const dados: any = {};
            dados.nome = this.nome;
            dados.descricao = this.descricao;
            dados.observacao = this.observacao;
            dados.status = this.statusId;
            return dados;
        }

        public sucesso() {
            this.$emit("espaco-cadastrado", null);
            this.nome = null;
            this.descricao = null;
            this.observacao = null;
            this.statusId = null;
            $("[data-bs-dismiss='modal']").trigger({ type: "click" });
        }

        public salvar() {
            if (this.processando || !this.hasPermissao) {
                return;
            }
            if (!this.nome || !this.descricao || !this.statusId) {
                SiteUtils.toastErro('Error!', 'Preencha nome, descricao e status.');
                return;
            }
            this.processando = true;
            const dados = this.getdados();
            setTimeout(() => {
                this.service.cadastrar(dados)
                    .then(response => {
                        SiteUtils.toastSucesso('Cadastrado com sucesso!', response.message);
                        this.sucesso();
                        this.processando = false;
                    })
                    .catch(error => {
                        this.processando = false;
                        SiteUtils.toastErro('Error!', error.data.message);
                    });
            }, 100);
        }
    }
